/* Fitpod.graph — extracted unchanged from design-system/components/bundle.js by scripts/extract-graph.mjs.
   Do not edit: re-run the script when the design system changes. */
(function () {
  /* ===================================================================
     Fitpod graph engine — geometry taken 1:1 from
     fitpod_template_weight-chart_editable_v01.svg (reference units = SVG px).
     One pure builder (svg string) used by static export, React and mount().
     =================================================================== */
  var G = {
    plotW: 792, edge: 60, gridTop: 108, gridGap: 114, gridLines: 5,
    areaBelow: 46, guideAbove: 18, minimalTop: 42,
    yLabelX: 811.4, yLabelShift: 11.2, xLabelBelow: 112.3,
    line: 6, dotR: 12.6, selR: 19.5, selStroke: 6.6, gridStroke: 3, dash: 12,
    tipW: 312, tipH: 138, tipRight: 30, tipPadX: 32.9, tipNumBase: 75.6, tipDateBase: 117.3, tipUnitGap: 11.6,
    fillTop: 1, fillBottom: 0.18, fillOpacity: 0.5,
    axisSize: 32, numSize: 66, unitSize: 27, dateSize: 30,
    fullW: 872.08, fullH: 685.66
  };
  var V = {
    dark: { line: ["--deep-green", "#12302B"], dot: ["--deep-green", "#12302B"], ring: ["--full-white", "#FFFFFF"],
      grid: ["--light-grey", "#AAABAB"], guide: ["--dark-grey", "#707073"], axis: ["--dark-grey", "#707073"],
      tip: ["--nature-grey", "#D5DBD7"], tipR: 27, num: ["--near-black", "#1E1E1E"], unit: ["--near-black", "#1E1E1E"], date: ["--dark-grey", "#707073"] },
    light: { line: ["--warm-paper", "#F6F5F0"], dot: ["--warm-paper", "#F6F5F0"], ring: ["--near-black", "#1E1E1E"],
      grid: ["--near-white", "#F1F1F1"], guide: ["--light-grey", "#AAABAB"], axis: ["--near-white", "#F1F1F1"],
      tip: ["--near-white", "#F1F1F1"], tipR: 27, num: ["--near-black", "#1E1E1E"], unit: ["--near-black", "#1E1E1E"], date: ["--dark-grey", "#707073"] },
    card: { line: ["--deep-green", "#12302B"], dot: ["--deep-green", "#12302B"], ring: ["--full-white", "#FFFFFF"],
      grid: ["--app-graph-grid", "#E9E9EC"], guide: ["--app-graph-guide", "#C9CBE0"], axis: ["--app-graph-label", "#BDBDC2"],
      tip: ["--app-graph-tooltip", "#E7E9F2"], tipR: 27, num: ["--app-graph-number", "#141414"], unit: ["--app-graph-number", "#141414"], date: ["--app-graph-date", "#8A8FA3"] }
  };
  var FONT = {
    app: "Inter, 'Red Hat Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    brand: "'Red Hat Display', Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif"
  };
  var NICE = [0.1, 0.2, 0.25, 0.3, 0.4, 0.5, 0.6, 0.8, 1, 1.5, 2, 2.5, 3, 4, 5, 10, 20, 25, 50, 100];

  function col(pair, isStatic) { return isStatic ? pair[1] : "var(" + pair[0] + ", " + pair[1] + ")"; }
  function r2(n) { return Math.round(n * 100) / 100; }
  function esc(s) { return String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;"); }

  /* Monotone cubic (Steffen, as d3.curveMonotoneX) with end tangents = the adjacent secant.
     Handles are 1/3 of the x step; extrema get horizontal handles. Reproduces the template exactly. */
  function tangents(pts) {
    var n = pts.length, t = new Array(n), s = [], h = [];
    for (var i = 0; i < n - 1; i++) { h[i] = pts[i + 1][0] - pts[i][0]; s[i] = (pts[i + 1][1] - pts[i][1]) / h[i]; }
    if (n === 2) { t[0] = t[1] = s[0]; return t; }
    t[0] = s[0]; t[n - 1] = s[n - 2];
    for (var k = 1; k < n - 1; k++) {
      var p = (s[k - 1] * h[k] + s[k] * h[k - 1]) / (h[k - 1] + h[k]);
      t[k] = ((s[k - 1] > 0) === (s[k] > 0) && s[k - 1] !== 0 && s[k] !== 0)
        ? (s[k] > 0 ? 1 : -1) * Math.min(Math.abs(s[k - 1]), Math.abs(s[k]), 0.5 * Math.abs(p)) * 2
        : 0;
    }
    return t;
  }
  function curve(pts) {
    if (pts.length === 1) return "";
    var t = tangents(pts), d = "";
    for (var i = 0; i < pts.length - 1; i++) {
      var a = pts[i], b = pts[i + 1], dx = (b[0] - a[0]) / 3;
      d += "C" + r2(a[0] + dx) + "," + r2(a[1] + t[i] * dx) + " " + r2(b[0] - dx) + "," + r2(b[1] - t[i + 1] * dx) + " " + r2(b[0]) + "," + r2(b[1]);
    }
    return d;
  }

  /* Y scale: explicit {min, step} wins; else the smallest nice step whose span is >= 2.5 x the data range,
     ticks on multiples of the step, data centred. */
  function scale(values, lines, ticks) {
    var lo = Math.min.apply(null, values), hi = Math.max.apply(null, values);
    var step, min;
    if (ticks && ticks.step) { step = ticks.step; min = ticks.min != null ? ticks.min : Math.floor((lo + hi) / 2 / step - (lines - 1) / 2) * step; }
    else {
      var need = Math.max(hi - lo, 0.1) * 2.5 / (lines - 1);
      step = NICE[NICE.length - 1];
      for (var i = 0; i < NICE.length; i++) if (NICE[i] >= need) { step = NICE[i]; break; }
      min = Math.round(((lo + hi) / 2 - step * (lines - 1) / 2) / step) * step;
      if (min > lo) min -= step;
      if (min + step * (lines - 1) < hi) min += step;
    }
    return { min: min, step: step, max: min + step * (lines - 1) };
  }
  function decimals(step) { var s = String(step); return s.indexOf(".") < 0 ? 0 : s.split(".")[1].length; }

  function normalize(data) {
    return (data || []).map(function (d, i) {
      return typeof d === "number" ? { value: d, label: String(i + 1), time: "" } : { value: +d.value, label: d.label != null ? String(d.label) : "", time: d.time || d.label || "" };
    });
  }

  /* build(opts, anim) -> { svg, width, height, points }
     opts: data, variant ("dark" | "light" | "card"), layout ("full" | "minimal"), selected, unit, ticks {min, step},
           tipDecimals, font ("app" | "brand"), static (plain hex, for files), title, id
     anim: { reveal 0..1, dots 0..1 per dot via reveal, chrome 0..1 (selected point, guides, tooltip) } */
  function build(opts, anim) {
    opts = opts || {}; anim = anim || { reveal: 1, chrome: 1 };
    var variant = V[opts.variant] ? opts.variant : "dark";
    var c = V[variant], st = !!opts.static;
    var data = normalize(opts.data);
    if (data.length < 2) data = normalize([71.2, 71.45, 71.3, 71.65, 71.55, 71.85, 71.95]);
    var n = data.length;
    var minimal = opts.layout === "minimal" && variant !== "card";
    var lines = minimal ? 4 : G.gridLines;
    var sel = opts.selected == null ? n - 1 : Math.max(0, Math.min(n - 1, opts.selected));
    var vals = data.map(function (d) { return d.value; });
    var sc = scale(vals, minimal ? 5 : lines, opts.ticks);
    var pxPerUnit = G.gridGap / sc.step;
    var top = minimal ? -(G.gridTop + G.gridGap - G.minimalTop) : 0; // minimal = full plot cropped above the 2nd gridline
    var gridY0 = G.gridTop + top + (minimal ? G.gridGap : 0);
    var yOf = function (v) { return G.gridTop + top + (sc.max - v) * pxPerUnit; };
    var step = (G.plotW - 2 * G.edge) / (n - 1);
    var pts = data.map(function (d, i) { return [G.edge + i * step, yOf(d.value)]; });
    var lastGrid = gridY0 + (lines - 1) * G.gridGap;
    var bottom = lastGrid + G.areaBelow;
    var guideTop = minimal ? 0 : G.gridTop - G.guideAbove;
    var W = minimal ? G.plotW : G.fullW, H = minimal ? bottom : G.fullH;
    var font = FONT[opts.font === "app" ? "app" : "brand"];
    var uid = opts.id || ("fpg" + Math.random().toString(36).slice(2, 8));
    var reveal = anim.reveal == null ? 1 : anim.reveal, chrome = anim.chrome == null ? 1 : anim.chrome;
    var revealX = reveal >= 1 ? W + 40 : reveal * (pts[n - 1][0] + G.selR + G.selStroke);
    var out = [];
    var minY = Math.min.apply(null, pts.map(function (p) { return p[1]; }));
    var p = function (s) { out.push(s); };

    p('<defs><linearGradient id="' + uid + '-fill" gradientUnits="userSpaceOnUse" x1="0" y1="' + r2(minY) + '" x2="0" y2="' + r2(bottom) + '">' +
      '<stop offset="0" stop-color="' + col(c.line, true) + '" stop-opacity="' + G.fillTop + '" style="stop-color:' + col(c.line, st) + '"/>' +
      '<stop offset="1" stop-color="' + col(c.line, true) + '" stop-opacity="' + G.fillBottom + '" style="stop-color:' + col(c.line, st) + '"/></linearGradient>' +
      '<clipPath id="' + uid + '-reveal"><rect x="-40" y="-40" width="' + r2(revealX + 40) + '" height="' + r2(H + 80) + '"/></clipPath></defs>');
    var dashed = ' stroke-width="' + G.gridStroke + '" stroke-dasharray="' + G.dash + ' ' + G.dash + '" fill="none"';
    // grid
    p('<g class="fpg-grid">');
    for (var g = 0; g < lines; g++) { var gy = gridY0 + g * G.gridGap; p('<line x1="0" y1="' + r2(gy) + '" x2="' + G.plotW + '" y2="' + r2(gy) + '"' + dashed + ' stroke="' + col(c.grid, true) + '" style="stroke:' + col(c.grid, st) + '"/>'); }
    p('</g>');
    // labels
    if (!minimal) {
      var dec = decimals(sc.step);
      p('<g class="fpg-axis" font-family="' + esc(font) + '" font-size="' + G.axisSize + '" fill="' + col(c.axis, true) + '" style="fill:' + col(c.axis, st) + '">');
      for (g = 0; g < lines; g++) {
        var v = sc.max - g * sc.step;
        p('<text x="' + G.yLabelX + '" y="' + r2(G.gridTop + g * G.gridGap + G.yLabelShift) + '">' + v.toFixed(dec) + '</text>');
      }
      var every = Math.ceil(n / 7);
      data.forEach(function (d, i) {
        if ((n - 1 - i) % every !== 0) return;
        p('<text x="' + r2(pts[i][0]) + '" y="' + r2(lastGrid + G.xLabelBelow) + '" text-anchor="middle">' + esc(d.label) + '</text>');
      });
      p('</g>');
    }
    // area + line (revealed left to right)
    var lead = "M0," + r2(pts[0][1]) + "H" + r2(pts[0][0]);
    var cv = curve(pts);
    p('<g clip-path="url(#' + uid + '-reveal)">');
    p('<path class="fpg-area" opacity="' + G.fillOpacity + '" fill="url(#' + uid + '-fill)" d="M0,' + r2(bottom) + "V" + r2(pts[0][1]) + "H" + r2(pts[0][0]) + cv + "V" + r2(bottom) + 'Z"/>');
    p('</g>');
    // guides
    var sx = pts[sel][0], sy = pts[sel][1];
    p('<g class="fpg-guides" opacity="' + r2(chrome) + '"' + dashed + ' stroke="' + col(c.guide, true) + '" style="stroke:' + col(c.guide, st) + '">' +
      '<line x1="0" y1="' + r2(sy) + '" x2="' + G.plotW + '" y2="' + r2(sy) + '"/>' +
      '<line x1="' + r2(sx) + '" y1="' + r2(guideTop) + '" x2="' + r2(sx) + '" y2="' + r2(bottom) + '"/></g>');
    p('<g clip-path="url(#' + uid + '-reveal)">');
    p('<path class="fpg-line" d="' + lead + '" fill="none" stroke-width="' + G.line + '" stroke="' + col(c.line, true) + '" style="stroke:' + col(c.line, st) + '"/>');
    p('<path class="fpg-line" d="M' + r2(pts[0][0]) + "," + r2(pts[0][1]) + cv + '" fill="none" stroke-width="' + G.line + '" stroke-linecap="round" stroke-linejoin="round" stroke="' + col(c.line, true) + '" style="stroke:' + col(c.line, st) + '"/>');
    p('</g>');
    // dots (pop in as the reveal passes them)
    p('<g class="fpg-dots" fill="' + col(c.dot, true) + '" style="fill:' + col(c.dot, st) + '">');
    pts.forEach(function (q, i) {
      if (i === sel) return;
      var k = reveal >= 1 ? 1 : Math.max(0, Math.min(1, (revealX - q[0] + G.dotR) / 70));
      if (k > 0) p('<circle cx="' + r2(q[0]) + '" cy="' + r2(q[1]) + '" r="' + r2(G.dotR * k) + '"/>');
    });
    p('</g>');
    // selected point
    if (chrome > 0) p('<circle class="fpg-selected" cx="' + r2(sx) + '" cy="' + r2(sy) + '" r="' + r2(G.selR * Math.min(1, 0.6 + chrome * 0.4)) + '" opacity="' + r2(chrome) + '" stroke-width="' + G.selStroke + '" fill="' + col(c.dot, true) + '" stroke="' + col(c.ring, true) + '" style="fill:' + col(c.dot, st) + ';stroke:' + col(c.ring, st) + '"/>');
    // tooltip
    if (!minimal && chrome > 0) {
      var tx = sx + G.tipRight - G.tipW; if (tx < 0) tx = sx - G.tipRight;
      var ty = (1 - chrome) * 12;
      var tdec = opts.tipDecimals == null ? 2 : opts.tipDecimals;
      var num = data[sel].value.toFixed(tdec);
      p('<g class="fpg-tip" opacity="' + r2(chrome) + '" transform="translate(0,' + r2(ty) + ')" font-family="' + esc(font) + '">' +
        '<rect x="' + r2(tx) + '" y="0" width="' + G.tipW + '" height="' + G.tipH + '" rx="' + c.tipR + '" fill="' + col(c.tip, true) + '" style="fill:' + col(c.tip, st) + '"/>' +
        '<text x="' + r2(tx + G.tipPadX) + '" y="' + G.tipNumBase + '" font-size="' + G.numSize + '" fill="' + col(c.num, true) + '" style="fill:' + col(c.num, st) + '">' + num +
        '<tspan dx="' + G.tipUnitGap + '" font-size="' + G.unitSize + '" fill="' + col(c.unit, true) + '" style="fill:' + col(c.unit, st) + '">' + esc(opts.unit || "kg") + '</tspan></text>' +
        '<text x="' + r2(tx + G.tipPadX - 1.6) + '" y="' + G.tipDateBase + '" font-size="' + G.dateSize + '" fill="' + col(c.date, true) + '" style="fill:' + col(c.date, st) + '">' + esc(data[sel].time) + '</text></g>');
    }
    var body = out.join("");
    var label = esc(opts.title || ("Trend graph, " + data[sel].value.toFixed(opts.tipDecimals == null ? 2 : opts.tipDecimals) + " " + (opts.unit || "kg")));
    var vb = minimal ? "0 0 " + G.plotW + " " + r2(H) : "0 0 " + G.fullW + " " + G.fullH;
    var svg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="' + vb + '" role="img" aria-label="' + label + '" style="display:block;width:100%;height:auto;overflow:visible">' + body + '</svg>';
    return { svg: svg, body: body, width: W, height: H, points: pts, selected: sel, scale: sc };
  }

  /* App card: the template's white card with tabs, header, stats and the card graph. */
  function buildCard(opts, anim) {
    opts = opts || {};
    var data = normalize(opts.data); if (data.length < 2) data = normalize([71.2, 71.45, 71.3, 71.65, 71.55, 71.85, 71.95]);
    var vals = data.map(function (d) { return d.value; });
    var hi = Math.max.apply(null, vals), lo = Math.min.apply(null, vals);
    var st = !!opts.static, f = FONT[opts.font === "app" ? "app" : "brand"];
    var graph = build(Object.assign({}, opts, { variant: "card", layout: "full" }), anim);
    var tabs = opts.tabs || ["whole", "D", "W", "30D", "90D"], active = opts.activeTab || 0;
    var a = function (pair) { return col(pair, st); };
    var s = [];
    var uid = (opts.id || "fpc") + "-sh";
    s.push('<defs><filter id="' + uid + '" x="-10%" y="-10%" width="120%" height="120%"><feGaussianBlur in="SourceAlpha" stdDeviation="12"/><feComponentTransfer><feFuncA type="linear" slope="0.25"/></feComponentTransfer><feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge></filter></defs>');
    s.push('<rect x="36" y="36" width="1083" height="1414" rx="66" fill="#FFFFFF" filter="url(#' + uid + ')"/>');
    s.push('<g transform="translate(36,36)" font-family="' + esc(f) + '">');
    s.push('<rect x="60" y="60" width="963" height="108" rx="36" style="fill:' + a(["--app-tab-bg", "#E8E8EA"]) + '" fill="#E8E8EA"/>');
    s.push('<rect x="' + r2(66 + active * 190.2) + '" y="66" width="190.2" height="96" rx="30" fill="#FFFFFF" stroke="#DCDCE0" stroke-width="1.5"/>');
    for (var i = 1; i < tabs.length; i++) { if (i === active || i === active + 1) continue; var lx = r2(66 + i * 190.2); s.push('<line x1="' + lx + '" y1="87" x2="' + lx + '" y2="141" stroke="#CFCFD3" stroke-width="3"/>'); }
    tabs.forEach(function (t, k) { s.push('<text x="' + r2(66 + 190.2 * (k + 0.5)) + '" y="125.6" text-anchor="middle" font-size="30" fill="#1A1A1A">' + esc(t) + '</text>'); });
    s.push('<text x="60" y="281" font-size="58" fill="#3A3A3C">' + esc(opts.metric || "Weight") + '</text>');
    s.push('<path d="M270,243h27l-13.5,16.5Z" fill="#8E8E93"/>');
    s.push('<text x="956" y="275" text-anchor="end" font-size="44" fill="#B3B3B8">' + esc(opts.period || "All day long") + '</text>');
    s.push('<path d="M993,246l13.5-13.5,13.5,13.5M993,261l13.5,13.5,13.5-13.5" fill="none" stroke="#A1A1A6" stroke-width="4.2" stroke-linecap="round" stroke-linejoin="round"/>');
    s.push('<text x="65" y="355" font-size="35" fill="#8A8FA3">' + esc(opts.range || "2026-09-23~2026-10-05") + '</text>');
    var dec = opts.tipDecimals == null ? 2 : opts.tipDecimals;
    [[87.9, hi, "Highest"], [640.2, lo, "Lowest"]].forEach(function (col_) {
      var num = col_[1].toFixed(dec);
      s.push('<text x="' + col_[0] + '" y="477.8" font-size="86" fill="#141414">' + num + '<tspan dx="16" font-size="27">' + esc(opts.unit || "kg") + '</tspan></text>');
      s.push('<text x="' + (col_[0] - 1) + '" y="537" font-size="36" fill="#A1A1A6">' + col_[2] + '</text>');
    });
    s.push('<g transform="translate(156,630)">' + graph.body + '</g>');
    s.push('</g>');
    var label = esc(opts.title || ((opts.metric || "Weight") + " card, highest " + hi.toFixed(dec) + ", lowest " + lo.toFixed(dec)));
    return { svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1155 1486" role="img" aria-label="' + label + '" style="display:block;width:100%;height:auto">' + s.join("") + '</svg>', graph: graph };
  }

  function svgFor(opts, anim) { return opts && opts.variant === "card" ? buildCard(opts, anim).svg : build(opts, anim).svg; }

  /* mount(el, opts): live graph for any web page — draws in, follows pointer and arrow keys, re-animates on update(). */
  var ease = function (t) { return 1 - Math.pow(1 - t, 3); };
  function reducedMotion() { try { return window.matchMedia("(prefers-reduced-motion: reduce)").matches; } catch (e) { return false; } }
  function mount(el, opts) {
    var state = { opts: Object.assign({}, opts), raf: 0, anim: { reveal: 1, chrome: 1 } };
    var id = "fpg" + Math.random().toString(36).slice(2, 8);
    state.opts.id = id;
    function paint() { el.innerHTML = svgFor(state.opts, state.anim); }
    function play() {
      cancelAnimationFrame(state.raf);
      if (state.opts.animate === false || reducedMotion()) { state.anim = { reveal: 1, chrome: 1 }; paint(); return; }
      var dur = state.opts.duration || 1400, chromeDur = 320, t0 = performance.now();
      (function frame(now) {
        var t = Math.min(1, (now - t0) / dur);
        var c = Math.max(0, Math.min(1, (now - t0 - dur) / chromeDur));
        state.anim = { reveal: ease(t), chrome: ease(c) };
        paint();
        if (c < 1) state.raf = requestAnimationFrame(frame);
      })(t0);
    }
    function select(i) {
      var n = (state.opts.data || []).length || 7;
      i = Math.max(0, Math.min(n - 1, i));
      if (i === state.opts.selected) return;
      state.opts.selected = i; paint();
      if (state.opts.onSelect) state.opts.onSelect(i);
    }
    function pointer(e) {
      if (state.opts.interactive === false || state.anim.chrome < 1) return;
      var svg = el.querySelector("svg"); if (!svg) return;
      var r = svg.getBoundingClientRect(), vb = svg.viewBox.baseVal;
      var x = (e.clientX - r.left) / r.width * vb.width - (state.opts.variant === "card" ? 192 : 0);
      var n = (state.opts.data || []).length || 7, stepX = (G.plotW - 2 * G.edge) / (n - 1);
      select(Math.round((x - G.edge) / stepX));
    }
    function key(e) {
      if (state.opts.interactive === false) return;
      var cur = state.opts.selected == null ? ((state.opts.data || []).length || 7) - 1 : state.opts.selected;
      if (e.key === "ArrowLeft") { select(cur - 1); e.preventDefault(); }
      if (e.key === "ArrowRight") { select(cur + 1); e.preventDefault(); }
    }
    if (state.opts.interactive !== false) { el.tabIndex = 0; el.addEventListener("pointermove", pointer); el.addEventListener("pointerdown", pointer); el.addEventListener("keydown", key); }
    var io = null;
    if (state.opts.animate !== false && state.opts.playOnView !== false && "IntersectionObserver" in window) {
      state.anim = { reveal: 0, chrome: 0 }; paint();
      io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { io.disconnect(); io = null; play(); } }, { threshold: 0.35 });
      io.observe(el);
    } else play();
    return {
      update: function (next, replay) { Object.assign(state.opts, next); if (replay) play(); else paint(); },
      replay: play,
      destroy: function () { cancelAnimationFrame(state.raf); if (io) io.disconnect(); el.removeEventListener("pointermove", pointer); el.removeEventListener("pointerdown", pointer); el.removeEventListener("keydown", key); el.innerHTML = ""; }
    };
  }

  var graph = { build: build, buildCard: buildCard, svg: svgFor, mount: mount, curve: curve, scale: scale, geometry: G, variants: V, fonts: FONT };

  window.Fitpod = window.Fitpod || {};
  window.Fitpod.graph = graph;
})();
